import { createSlice, PayloadAction } from "@reduxjs/toolkit";
export interface ParticipantTabState {
  categoryType: string;
  menuType: string;
  toggleLoader: boolean;
  assignable: boolean;
  // True when the participant is locked (deactivated/redacted/deleted).
  // Surfaces that mutate participant-generated data read this to disable edits.
  isLocked: boolean;
}

const initialState: ParticipantTabState = {
  categoryType: "",
  menuType: "",
  toggleLoader: false,
  assignable: false,
  isLocked: false,
};

const getIntialState = (): ParticipantTabState => {
  const categoryType = sessionStorage?.getItem("category-type") ?? "";
  const menuType = sessionStorage?.getItem("menu-type") ?? "";
  return {
    ...initialState,
    categoryType,
    menuType,
  };
};

export const participantTabSlice = createSlice({
  name: "participantTab",
  initialState: getIntialState(),
  reducers: {
    setTabCategoryType: (state, action: PayloadAction<string>) => {
      state.categoryType = action.payload;
    },
    setTabMenuType: (state, action: PayloadAction<string>) => {
      state.menuType = action.payload;
    },
    setToggleLoader: (state) => {
      state.toggleLoader = !state.toggleLoader;
    },
    setParticipantAssignable: (state, action: PayloadAction<boolean>) => {
      state.assignable = action.payload;
    },
    setParticipantLocked: (state, action: PayloadAction<boolean>) => {
      state.isLocked = action.payload;
    },
    reset: () => initialState,
  },
});

export const {
  setTabCategoryType,
  setTabMenuType,
  setToggleLoader,
  setParticipantAssignable,
  setParticipantLocked,
  reset,
} = participantTabSlice.actions;

export default participantTabSlice.reducer;
